import React, { useRef } from 'react';
import { Paper, Box, Typography, Button } from '@mui/material';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import ScrollDialog from './detectDevice/ScrollDialog';

function CardWallPost (props) {
  const scrollDialogRef = useRef(null);

  const handleInstallClick = () => {
    // Access the ScrollDialog's button via the ref and trigger its click
    if (scrollDialogRef.current) {
      const button = scrollDialogRef.current.querySelector('button');
      if (button) button.click();
    }
  };

  return (
    <Paper
      elevation={2}
      sx={{
        borderRadius: 3,
        overflow: 'hidden',
        mb: 1.5,
        position: 'relative',
        background: 'linear-gradient(135deg, #3d6e75 0%, #2e5a60 100%)',
        border: '1px solid rgba(255,255,255,0.1)',
        transition: 'all 0.2s ease',
        '&:hover': {
          boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
          transform: 'translateY(-2px)'
        }
      }}
    >
      <Box sx={{ p: 3, color: 'white' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Box
            sx={{
              backgroundColor: 'rgba(255,255,255,0.15)',
              borderRadius: '50%',
              p: 1.5,
              mr: 2.5,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <PhoneIphoneIcon sx={{ fontSize: 28 }} />
          </Box>
          <Box>
            <Typography variant="h5" component="h2" fontWeight="600" sx={{ mb: 0.5 }}>
              Install Our App
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              Use mattool.in like a regular app on your phone
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
          <Button
            variant="outlined"
            disableElevation
            onClick={handleInstallClick}
            sx={{
              mt: 1,
              py: 1,
              px: 2.5,
              borderColor: 'rgba(255,255,255,0.3)',
              color: 'white',
              textTransform: 'none',
              fontWeight: '600',
              fontSize: '0.95rem',
              borderRadius: 8,
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.1)',
                borderColor: 'rgba(255,255,255,0.5)'
              }
            }}
          >
            Show me how to install
          </Button>
        </Box>
      </Box>
      
      {/* ScrollDialog with a div wrapper so we can reference it */}
      <div ref={scrollDialogRef} style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }}>
        <ScrollDialog />
      </div>
    </Paper>
  );
}

export default CardWallPost;

{/* <div style={{ marginLeft: '1rem', marginRight: '1rem' }}>
<a  style={{ display: "flex", textAlign: "center", justifyContent: "center", textDecoration: "none",
   color: "green",  borderStyle: "double", padding: "0.5rem", borderRadius: "0.5rem", marginBottom: "0.5rem" }}  */}



  